var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Touchable = _interopRequireDefault(require("../../Basic/Touchable"));

var _Basic = require("../../../../elements/Basic");

var _TransferComponents = require("../TransferComponents");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Transfers/Player/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var PlayerTransfer = function (_React$Component) {
  (0, _inherits2.default)(PlayerTransfer, _React$Component);

  var _super = _createSuper(PlayerTransfer);

  function PlayerTransfer() {
    (0, _classCallCheck2.default)(this, PlayerTransfer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PlayerTransfer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          transfer = _this$props.transfer,
          teamName = _this$props.teamName,
          _onPress = _this$props.onPress,
          href = _this$props.href,
          durationStyles = _this$props.durationStyles,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["transfer", "teamName", "onPress", "href", "durationStyles"]);
      return transfer ? _react.default.createElement(_Touchable.default, {
        onPress: function onPress() {
          return _onPress(transfer.team);
        },
        href: href,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        center: true,
        mb: 2,
        p: 2,
        borderX: 1,
        borderY: 1,
        borderColor: "border.main"
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20,
          columnNumber: 17
        }
      }), _react.default.createElement(_TransferComponents.TransferDuration, (0, _extends2.default)({
        mr: 2,
        joinDate: transfer.joinDate,
        leaveDate: transfer.leaveDate,
        minWidth: 72
      }, durationStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 21
        }
      })), _react.default.createElement(_TransferComponents.TeamLabel, {
        bold: true,
        team: transfer.team,
        teamName: teamName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 21
        }
      }), _react.default.createElement(_TransferComponents.PlayerLoan, {
        loan: transfer.loan,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 21
        }
      }))) : null;
    }
  }]);
  return PlayerTransfer;
}(_react.default.Component);

PlayerTransfer.propTypes = {
  transfer: _propTypes.default.object.isRequired,
  onPress: _propTypes.default.func,
  durationStyles: _propTypes.default.object,
  href: _propTypes.default.string
};
var _default = PlayerTransfer;
exports.default = _default;